import { useState } from "react";

import { Link } from "easy-page-router/react";
import { ContentSwitch, Page } from "../components";
import { LangSwitch } from "../components/Lang";
import LaunchButton from "../components/LaunchButton";
import { ThemeSwitch } from "../components/Theme";
import { Footer, Header } from "../Layout";
import { useHead } from "../services/common";
import { useLang } from "../services/lang";

export default function Donate() {
    const { lang, dict } = useLang();

    useHead({
        title: dict.seo.donate.title,
        description: dict.seo.donate.description,
    });


    return <Page fixed={<>
        <Header title={dict.donate} link={`/${dict.urlDonate}`}>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
    </>}>
        {lang === "cs" && <DonateCS />}
        {lang === "en" && <DonateEN />}
        {lang === "es" && <DonateES />}
    </Page>;
}

function DonateCS() {
    const { lang, dict } = useLang();

    const [contentIndex, setContentIndex] = useState(2);

    return <div className="donate-page">
        <h1>Podpořte ajťáka, který bojuje proti chaosu</h1>

        <ContentSwitch
            index={contentIndex}
            onChange={setContentIndex}
            options={[{
                title: <><span className="no-mobile">Buy Me a </span>Coffee</>,
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>☕ Buy Me a Coffee</h3>
                        <p className="info">Pro celý svět a okolí</p>
                        <p>Je to univerzální a funguje pro kohokoliv a odkudkoliv. Váš příspěvek i návrh na vylepšení může být veřejný, takže se můžete hrdě hlásit k tomu, že pomáháte krotit chaos. (Nebo zůstat v anonymitě, je to na vás).</p>
                    </div>
                    <div className="right">
                        <a href="https://www.buymeacoffee.com/filippaulu" target="_blank" className="block coffee-button">
                            <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style={{ height: "60px", width: "217px" }} />
                        </a>
                    </div>
                </div>,
            }, {
                title: "Revolut",
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>🚀 Revolut</h3>
                        <p className="info">Pro finanční high-tech ninji</p>
                        <p>Pokud je pro vás Revolut denní chléb, je tohle cesta pro vás. Moderní, efektivní a bez zbytečných klikání.</p>
                        <p className="info">Do poznámky klidně připište váš nápad na vylepšení!</p>
                    </div>
                    <div className="right">
                        <a href="https://revolut.me/filipgd3q" target="_blank" className="block revolut-button">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Revolut_logo.svg/250px-Revolut_logo.svg.png" /> Pay
                        </a>
                    </div>
                </div>,
            }, {
                title: <>QR Platba</>,
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <div className="donate-qr" />
                        <h3>🏦 QR Platba</h3>
                        <p className="info">Pouze pro platby <strong>v Česku</strong>!</p>
                        <p>Rychlý a bezbolestný způsob pro všechny, kdo mají české bankovní konto a chytrý telefon. Píp... a je hotovo.</p>
                        <p className="info">Do poznámky pro příjemce klidně připište váš nápad na vylepšení!</p>
                    </div>
                </div>,
            }]}
        />

        <h2>Proč byste mi měli kupovat kafe?</h2>
        <p>Jsem <a target="_blank" href="https://paulu.cz">Filip</a>. A pokud jste jako já, váš kalendář občas vypadá jako abstraktní umění a snaha domluvit se s pěti lidmi na jednom termínu má složitost startu raketoplánu. Přesně proto vznikl <Link href={`/${dict.url}`}>titimeme.com</Link>. Nebudu vám lhát, že jsem nějaký guru produktivity. Naopak. Tuhle sadu nástrojů jsem postavil primárně pro sebe, protože jsem zoufale potřeboval něco, co by mi pomohlo zorganizovat si čas a synchronizovat se s ostatními, aniž by z toho všichni zešíleli.</p>
        <p>Ukázalo se, že v tomhle chaosu nejsem sám. A proto je tenhle web tady pro vás – <strong>zcela zdarma</strong>. Je to můj pokus, jak nám všem trochu ulehčit plánování a sdílení s přáteli, kolegy nebo rodinou.</p>

        <h2>Pojďme uzavřít dohodu</h2>
        <p>Provoz serverů a neustálé vylepšování něco stojí – jak peníze, tak i čas. Pokud se vám nástroje líbí a alespoň trochu vám pomáhají, můžete mě na oplátku pozvat na kafe.</p>
        <p>
            <strong>A tady je můj slib:</strong> Dokud bude vaše podpora stačit na pokrytí nákladů (a občasného kofeinu na probdělé noci u kódu), <strong>NIKDY</strong> na tomto webu neuvidíte otravné reklamy ani žádné placené "prémiové" funkce. <strong>Všechno zůstane přístupné a zdarma. Pro všechny.</strong>
        </p>

        <h2>Chcete něco podobného ve vaší firmě?</h2>
        <p>
            Používáte v práci nástroje, které vypadají, jako by je navrhl někdo v roce 1998? Pokud by se vám hodila jakákoliv část tohoto webu nebo upravená verze přímo na míru (třeba tajné hlasování) pro vaši firmu, společnost nebo úřad, neváhejte se ozvat. Rád proberu možnosti, jak vám usnadnit život.
        </p>

        <p>
            Díky moc, <a target="_blank" href="https://paulu.cz">Filip</a>,<br />
            Hlavní (a jediný) ajťák bojující proti chaosu s <Link href={`/${dict.url}`}>titimeme.com</Link>
        </p>
    </div>;
}

function DonateEN() {
    const { dict } = useLang();

    const [contentIndex, setContentIndex] = useState(0);

    return <div className="donate-page">
        <h1>Support the developer who fights against chaos</h1>

        <ContentSwitch
            index={contentIndex}
            onChange={setContentIndex}
            options={[{
                title: <><span className="no-mobile">Buy Me a </span>Coffee</>,
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>☕ Buy Me a Coffee</h3>
                        <p className="info">For the whole world and beyond</p>
                        <p>It's universal and works for anyone, anywhere. Your contribution and suggestion can be public, so you can proudly claim you're helping to tame the chaos. (Or you can stay anonymous, it's up to you).</p>
                    </div>
                    <div className="right">
                        <a href="https://www.buymeacoffee.com/filippaulu" target="_blank" className="block coffee-button">
                            <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style={{ height: "60px", width: "217px" }} />
                        </a>
                    </div>
                </div>,
            }, {
                title: "Revolut",
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>🚀 Revolut</h3>
                        <p className="info">For high-tech financial ninjas</p>
                        <p>If Revolut is your daily bread, this is the way for you. Modern, efficient, and without unnecessary clicks.</p>
                        <p className="info">Feel free to add your idea for improvement in the note!</p>
                    </div>
                    <div className="right">
                        <a href="https://revolut.me/filipgd3q" target="_blank" className="block revolut-button">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Revolut_logo.svg/250px-Revolut_logo.svg.png" alt="Revolut" /> Pay
                        </a>
                    </div>
                </div>,
            }, {
                title: <>QR <span className="no-mobile">Payment</span></>,
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <div className="donate-qr" />
                        <h3>🏦 QR Payment</h3>
                        <p className="info">Only for payments <strong>in Czechia</strong>!</p>
                        <p>A quick and painless way for everyone who has a Czech bank account and a smartphone. Beep... and it's done.</p>
                        <p className="info">Feel free to add your idea for improvement in the payment note!</p>
                    </div>
                </div>,
            }]}
        />

        <h2>So, why should you buy me a coffee?</h2>
        <p>I'm <a target="_blank" href="https://paulu.cz">Filip</a>. And if you're like me, your calendar sometimes looks like abstract art, and trying to agree on a single time with five people has the complexity of a space shuttle launch. That's exactly why <Link href={`/${dict.url}`}>titimeme.com</Link> was created. I'm not going to lie and say I'm some productivity guru. Quite the opposite. I built this set of tools primarily for myself because I desperately needed something to help me organize my time and sync up with others without everyone going crazy.</p>
        <p>It turned out I'm not alone in this chaos. And that's why this website is here for you – <strong>completely free</strong>. It's my attempt to make planning and sharing a bit easier for all of us, whether with friends, colleagues, or family.</p>

        <h2>Let's make a deal</h2>
        <p>Running the servers and constant improvement costs something – both time and money. If you like the tools and they help you even a little, you can buy me a coffee in return.</p>
        <p>
            <strong>And here's my promise:</strong> As long as your support is enough to cover the costs (and the occasional caffeine for late-night coding), you will <strong>NEVER</strong> see annoying ads or any paid "premium" features on this site. <strong>Everything will remain accessible and free. For everyone.</strong>
        </p>

        <h2>Want something similar for your company?</h2>
        <p>
            Are you using tools at work that look like they were designed in 1998? If you could use any part of this website or a custom-tailored version (like a secret voting feature, for example) for your company, business, or office, don't hesitate to get in touch. I'd be happy to discuss how I can make your life easier.
        </p>

        <p>
            Thanks a lot, <a target="_blank" href="https://paulu.cz">Filip</a>,<br />
            The main (and only) developer fighting chaos with <Link href={`/${dict.url}`}>titimeme.com</Link>
        </p>
    </div>;
}

function DonateES() {
    const { dict } = useLang();

    const [contentIndex, setContentIndex] = useState(0);

    return <div className="donate-page">
        <h1>Apoya al desarrollador que lucha contra el caos</h1>

        <ContentSwitch
            index={contentIndex}
            onChange={setContentIndex}
            options={[{
                title: <><span className="no-mobile">Buy Me a </span>Coffee</>,
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>☕ Buy Me a Coffee</h3>
                        <p className="info">Para todo el mundo y más allá</p>
                        <p>Es universal y funciona para cualquiera, desde cualquier lugar. Tu contribución y tu sugerencia pueden ser públicas, así que puedes proclamar con orgullo que estás ayudando a domar el caos. (O puedes permanecer en el anonimato, como tú prefieras).</p>
                    </div>
                    <div className="right">
                        <a href="https://www.buymeacoffee.com/filippaulu" target="_blank" className="block coffee-button">
                            <img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style={{ height: "60px", width: "217px" }} />
                        </a>
                    </div>
                </div>,
            }, {
                title: "Revolut",
                content: <div className="donate-method block">
                    <div className="grow-1">
                        <h3>🚀 Revolut</h3>
                        <p className="info">Para ninjas de las finanzas high-tech</p>
                        <p>Si Revolut es tu pan de cada día, este es tu camino. Moderno, eficiente y sin clics innecesarios.</p>
                        <p className="info">¡No dudes en añadir tu idea de mejora en la nota!</p>
                    </div>
                    <div className="right">
                        <a href="https://revolut.me/filipgd3q" target="_blank" className="block revolut-button">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Revolut_logo.svg/250px-Revolut_logo.svg.png" alt="Revolut" /> Pagar
                        </a>
                    </div>
                </div>,
            }]}
        />

        <h2>¿Y por qué deberías invitarme un café?</h2>
        <p>Soy <a target="_blank" href="https://paulu.cz">Filip</a>. Y si eres como yo, tu calendario a veces parece arte abstracto, y tratar de acordar una hora con cinco personas tiene la complejidad de un lanzamiento espacial. Exactamente por eso nació <Link href={`/${dict.url}`}>titimeme.com</Link>. No voy a mentir diciendo que soy un gurú de la productividad. Todo lo contrario. Construí este conjunto de herramientas principalmente para mí, porque necesitaba desesperadamente algo que me ayudara a organizar mi tiempo y a sincronizarme con los demás sin que todos se volvieran locos.</p>
        <p>Resultó que no estoy solo en este caos. Y por eso esta web está aquí para ti, <strong>totalmente gratis</strong>. Es mi intento de hacer la planificación y el compartir un poco más fácil para todos, ya sea con amigos, colegas o familia.</p>

        <h2>Hagamos un trato</h2>
        <p>El mantenimiento de los servidores y la mejora constante cuestan algo: tanto tiempo como dinero. Si te gustan las herramientas y te ayudan aunque sea un poco, puedes invitarme a un café a cambio.</p>
        <p>
            <strong>Y aquí está mi promesa:</strong> Mientras su apoyo sea suficiente para cubrir los costes (y la cafeína ocasional para las noches de programación), <strong>NUNCA</strong> verás anuncios molestos ni funciones "premium" de pago en esta web. <strong>Todo seguirá siendo accesible y gratis. Para todos.</strong>
        </p>

        <h2>¿Quieres algo similar en tu empresa?</h2>
        <p>
            ¿Usas en el trabajo herramientas que parecen diseñadas en 1998? Si te vendría bien cualquier parte de esta web o una versión a medida (como por ejemplo, una votación secreta) para tu compañía, empresa u oficina, no dudes en contactarme. Estaré encantado de discutir las opciones para hacerte la vida más fácil.
        </p>

        <p>
            ¡Muchas gracias!, <a target="_blank" href="https://paulu.cz">Filip</a>,<br />
            El desarrollador principal (y único) que lucha contra el caos con <Link href={`/${dict.url}`}>titimeme.com</Link>
        </p>
    </div>;
}